import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext } from "react";
import modalContext from "../../../dataManager/context/modalContext";
import EditProduct from "./sections/EditProduct";
import DeleteProduct from "./sections/DeleteProduct";
import DeleteCategory from "./sections/DeleteCategory";
import EditCategory from "./sections/EditCategory";
import H3 from "../../elements/titles/H3";
import EditUser from "./sections/EditUser";
import ShareProduct from "./sections/ShareProduct";
import UnsaveProduct from "./sections/UnsaveProduct";
import ChangeUserAlreadyContacted from "./sections/ChangeUserAlreadyContacted";
import UpdatePassword from "./sections/UpdatePassword";
import EditAdmin from "./sections/EditAdmin";

export default function MyModal() {
  //context section
  const { isOpen, modalCode, modalTitle, onClose } = useContext(modalContext);

  function generateModalContent(code) {
    switch (code) {
      case "EDIT_PRODUCT":
        return <EditProduct />;
      case "DELETE_PRODUCT":
        return <DeleteProduct />;
      case "EDIT_CATEGORY":
        return <EditCategory />;
      case "DELETE_CATEGORY":
        return <DeleteCategory />;
      case "EDIT_USER":
        return <EditUser />;
      case "SHARE_PRODUCT":
        return <ShareProduct />;
      case "UNSAVE_PRODUCT":
        return <UnsaveProduct />;
      case "CHANGE_USER_ALREADY_CONTACTED":
        return <ChangeUserAlreadyContacted />;
      case "UPDATE_PASSWORD_ADMIN":
        return <UpdatePassword />;
      case "EDIT_ADMIN":
        return <EditAdmin />;
      default:
        return null;
    }
  }

  return (
    <Transition appear show={isOpen} as={Fragment} className="relative z-[500]">
      <Dialog as="div" className="relative z-10" onClose={() => onClose()}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 -z-10 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="relative flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-5 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3">
                  <H3>{modalTitle}</H3>
                </Dialog.Title>
                <div className="mt-2">{generateModalContent(modalCode)}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
